<div *ngIf="person?.demographics?.alsdeId" class="person-card">
    <div class="person-row-top">
        <mat-icon class="person-icon">person</mat-icon>
        <span class="person-name">{{personName}}</span>
        <span class="person-id">{{person.demographics.alsdeId}}</span>
        <div class="spacer"></div>
        <div class="person-bgr" [ngClass]="bgrClass">
            <mat-icon *ngIf="bgrClass === 'bgr-pass'" class="bgr-icon">check_circle</mat-icon>
            <mat-icon *ngIf="bgrClass === 'bgr-fail'" class="bgr-icon">gpp_bad</mat-icon>
            <mat-icon *ngIf="bgrClass === 'bgr-pending'" class="bgr-icon">schedule</mat-icon>
            <span>{{bgrStatus}}</span>
        </div>
    </div>
    <div class="person-row-details">
        <span *ngIf="person.demographics?.birthDetails?.dateOfBirth">DOB: {{person.demographics.birthDetails.dateOfBirth | date:'MM/dd/yyyy'}}</span>
        <span *ngIf="person.demographics?.sex" class="detail-sep">{{person.demographics.sex}}</span>
        <span *ngIf="person.demographics?.workPhone || person.demographics?.cellPhone" class="detail-sep">{{person.demographics.workPhone || person.demographics.cellPhone}}</span>
        <span *ngIf="personEmail" class="detail-sep">{{personEmail}}</span>
    </div>
</div>
